import React from 'react'
import Lottie from 'react-lottie'
import { makeStyles } from '@material-ui/core/styles'

import { Loading } from '../../Commons/lottiefiles'

const useStyle = makeStyles({
  container: {
    width: '100%',
    height: '100%',
    backgroundColor: '#03B0EE',
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
})

export default () => {
  const classes = useStyle()

  return (
    <div className={classes.container}>
      <Lottie
        options={{
          loop: true,
          autoplay: true,
          animationData: Loading,
        }}
        height='50%'
        width='50%'
        isClickToPauseDisabled
      />
    </div>
  )
}
